// @flow

import React from 'react';
import { connect } from 'react-redux';
import {
  getDoors,
  getFuelInfo,
  getKeys,
  getTitle,
} from '../../store/componentSettings/selectors/pdbSpecificationSettings';
import {
  getEngine,
  getPower,
  getConsumption,
  getFueltype,
  getTransmission,
  getDoorCount,
  getKmPrice,
} from '../../store/pdb/selectors';
import type { FuelInfo } from '../../types';
import SpecificationsComponent from './specifications';
import { priceFormat } from '../../helpers';

type StateProps = {|
  title: string,
  keys: {
    [key: 'engine' | 'fuel' | 'power' | 'consumption' | 'transmission' | 'doors' | 'kmprice']: string,
  },
  doors: string,
  fuelinfo: ?FuelInfo,
  engine: string,
  power: string,
  consumption: string,
  fueltype: string,
  transmission: string,
  doorCount: number,
  kmPrice: number,
|};

type Props = StateProps;

const Specifications = ({
  title,
  keys,
  doors,
  fuelinfo,
  engine,
  power,
  consumption,
  fueltype,
  transmission,
  doorCount,
  kmPrice,
}: Props) => (
  <SpecificationsComponent
    title={title}
    specifications={[{
      key: keys.engine,
      value: engine,
    }, {
      key: keys.fuel,
      value: fueltype,
    }, {
      key: keys.power,
      value: power,
    }, {
      key: keys.consumption,
      value: consumption,
      info: fuelinfo,
    }, {
      key: keys.transmission,
      value: transmission,
    }, {
      key: keys.doors,
      value: `${doorCount} ${doors}`,
    }, {
      key: keys.kmprice,
      value: priceFormat(kmPrice / 100),
    }]}
  />
);

const mapStateToProps = (state): StateProps => ({
  title: getTitle(state),
  keys: getKeys(state),
  doors: getDoors(state),
  fuelinfo: getFuelInfo(state),
  engine: getEngine(state),
  power: getPower(state),
  consumption: getConsumption(state),
  fueltype: getFueltype(state),
  transmission: getTransmission(state),
  doorCount: getDoorCount(state),
  kmPrice: getKmPrice(state),
});

Specifications.defaultProps = {
  fuelinfo: null,
};

export default connect<Props, any, StateProps, any, any, any>(mapStateToProps)(Specifications);
